import type { AxiosInstance } from 'axios';

import {
  getLocalDevToken,
  isLocalDevTokenAllowed
} from '../utils/localDevToken';

/**
 * Runs before the auth-client-lib interceptor (axios LIFO).
 * When Authorization is already set, the lib skips Redis/get-user-tokens.
 */
export function attachLocalDevTokenInterceptor(instance: AxiosInstance): void {
  if (!isLocalDevTokenAllowed()) {
    return;
  }

  instance.interceptors.request.use(config => {
    const token = getLocalDevToken();
    if (!token) {
      return config;
    }

    const headers = config.headers ?? {};

    if (typeof headers.set === 'function') {
      headers.set('Authorization', `Bearer ${token}`);
    } else {
      (headers as Record<string, string>).Authorization = `Bearer ${token}`;
    }

    config.headers = headers;
    return config;
  });
}
